export const PasswordRegex = {
  pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[.@$!%*?&_-])[A-Za-z\d.@$!%*?&_]{8,}$/,
  message: 'Password must contain at least 8 characters, including one uppercase letter, one lowercase letter, one number and one special character (@, $, !, %, *, ?, &, _ or -)',
};